import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  setLoginModalOpen,
  setLoginMode,
  setOrganizations,
  signOut,
} from '../Actions/Login.action';
import Popover from '../Components/Popover/Popover';
import useIsAuthenticated from '../Hooks/useIsAuthenticated';
import Icon from '../Components/Icon';
import { translate } from '../Services/translation';
import { LoginModes } from '../constants';

const MyAccountDesktopContainer = () => {
  const isAuthenticated = useIsAuthenticated();
  const dispatch = useDispatch();
  const { person, pageUrl, links, organizations } = useSelector(
    (state) => state.myPage.menu
  );

  const MyAccountButtonTrigger = () => {
    return (
      <div className="link-menu__trigger">
        <Icon name="Person" size={24} className="link-menu__trigger-icon" />
        <div className="link-menu__trigger-content">
          <span className="link-menu__trigger-org">
            {person.currentOrganization && person.currentOrganization}
          </span>
          <span className="link-menu__trigger-name">
            {person.name && person.name}
          </span>
        </div>
        <Icon
          name="Caret-Down"
          size={20}
          className="link-menu__trigger-icon link-menu__trigger-icon--caret"
        />
      </div>
    );
  };

  const onChangeOrgClick = () => {
    dispatch(setOrganizations(organizations));
    dispatch(setLoginMode(LoginModes.SelectOrganization));
    dispatch(setLoginModalOpen(true));
  };

  const MyAccountPanelComponent = () => {
    return (
      <div className="link-menu link-menu--header">
        {organizations && organizations.length > 1 && (
          <>
            <button
              className="link-menu__item"
              onClick={() => onChangeOrgClick()}
            >
              <Icon
                size={24}
                name="Home-Cog"
                className="link-menu__item-icon"
              />
              <span className="link-menu__item-label">
                {translate('mypages.changeorg')}
              </span>
            </button>
            <div className="link-menu__divider"></div>
          </>
        )}
        {links &&
          !!links.length &&
          links.map((link, index) =>
            !link.isDivider ? (
              <a
                href={pageUrl + '#' + link.urlParam}
                className="link-menu__item"
                key={link.label + '-desktop'}
              >
                {link.icon && (
                  <Icon
                    size={24}
                    name={link.icon}
                    className="link-menu__item-icon"
                  />
                )}
                {link.label && (
                  <span className="link-menu__item-label">{link.label}</span>
                )}
              </a>
            ) : (
              <div
                className="link-menu__divider"
                key={'divider-' + index}
              ></div>
            )
          )}
        <button className="link-menu__item" onClick={signOut}>
          <Icon size={24} name="Sign-Out" className="link-menu__item-icon" />
          <span className="link-menu__item-label">
            {translate('mypages.signout')}
          </span>
        </button>
      </div>
    );
  };

  return (
    <>
      {!isAuthenticated && (
        <button
          onClick={() => dispatch(setLoginModalOpen(true))}
          className="link-menu__trigger"
        >
          <Icon name="Person" size={24} className="link-menu__trigger-icon" />
          {translate('general.signin')}
        </button>
      )}
      {isAuthenticated && (
        <Popover
          buttonContent={<MyAccountButtonTrigger />}
          id={'myAccountPanel'}
          panelAlignment="right"
        >
          <MyAccountPanelComponent />
        </Popover>
      )}
    </>
  );
};

export default MyAccountDesktopContainer;
